import { INCOMPLETE_SURVEYS } from '../constants';
import localStorage from '../../../utils/localStorage';

export const getIncompleteSurveys = () => localStorage.getItem(INCOMPLETE_SURVEYS) ?? [];

export const getIncompleteSurvey = (nodeId, flowId) => {
  const incompleteSurveys = getIncompleteSurveys();

  return incompleteSurveys.find((survey) => survey.nodeId === nodeId && survey.flowId === flowId);
};

export const addIncompleteSurvey = (feedbackId, nodeId, flowId, version) => {
  const incompleteSurveys = getIncompleteSurveys();

  const index = incompleteSurveys.findIndex((survey) => survey.nodeId === nodeId && survey.flowId === flowId);
  if (index !== -1) incompleteSurveys.splice(index, 1);

  incompleteSurveys.push({ feedbackId, nodeId, flowId, version });

  localStorage.setItem(INCOMPLETE_SURVEYS, incompleteSurveys);
};

export const removeIncompleteSurveyByNodeAndFlow = (nodeId, flowId) => {
  const incompleteSurveys = getIncompleteSurveys();
  const updatedIncompleteSurveys = incompleteSurveys.filter(
    (survey) => survey.nodeId !== nodeId || survey.flowId !== flowId,
  );

  localStorage.setItem(INCOMPLETE_SURVEYS, updatedIncompleteSurveys);
};

export const removeIncompleteSurveyByFeedbackId = (feedbackId) => {
  const incompleteSurveys = getIncompleteSurveys();
  const updatedIncompleteSurveys = incompleteSurveys.filter((survey) => survey.feedbackId !== feedbackId);

  localStorage.setItem(INCOMPLETE_SURVEYS, updatedIncompleteSurveys);
};
